export const FUND_DIALOG_FORM_ADD_FUND = 'Add Fund';
export const FUND_DIALOG_FORM_DELETE_FUND = 'Delete Fund';

export const FUND_DIALOG_FORM_NAME = 'Name';
export const FUND_DIALOG_FORM_TOTAL_COMMITTED_CAPITAL = 'Total Committed Capital';
export const FUND_DIALOG_FORM_FUND_CURRENCY = 'Fund Currency';
